'use client'

import {useRef, useState} from 'react'
import {WindowEvent} from './useWindowEvent'
import useWindowResize from './useWindowResize'

export interface WindowSize {
	innerWidth: number
	innerHeight: number
	documentHeight: number
}

const useWindowSize = (asRef = false, debounce = 0) => {
	const ref = useRef<WindowSize>({innerWidth: 0, innerHeight: 0, documentHeight: 0})
	const [windowSize, setWindowSize] = useState<WindowSize>({
		innerWidth: 0,
		innerHeight: 0,
		documentHeight: 0,
	})

	useWindowResize(
		(e: WindowEvent) => {
			ref.current.innerWidth = e?.innerWidth || 0
			ref.current.innerHeight = e?.innerHeight || 0
			ref.current.documentHeight = e?.documentHeight || 0

			setWindowSize(ref.current)
		},
		true,
		[],
		debounce,
	)

	return asRef ? ref : windowSize
}

export default useWindowSize
